import produce from "immer";

import { CombinedCandidatesFeatureActionTypes } from "..";
import { CandidateState } from "../candidateState";
import names from "./uiActionTypes";

// follow example of admin candidates
export const uiReducer = (
    state: CandidateState,
    action: CombinedCandidatesFeatureActionTypes
): CandidateState => {
    const newState = produce(state, draft => {
        switch (action.type) {
            case names.SET_SELECTED_LEAD_TAB: {
                draft.ui.selectedCandidateTab = action.payload.tab;
                break;
            }
            case names.CLEAR_ERROR: {
                draft.ui.error = undefined;
                break;
            }
        }
    });
    return newState;
};
